/*
 * Jira Ticket:
 * Created Date: Thu, 4th Jun 2020, 09:54:10 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const createSubscriptionTierMutation = gql`
  mutation CreateSubscriptionTier(
    $name: String!
    $monthlyCost: MoneyInput
    $annualCost: MoneyInput
    $freeTrialDuration: NonNegativeInt
    $maximumEmployees: NonNegativeInt!
    $maximumSubcontractors: NonNegativeInt!
    $maximumProjects: NonNegativeInt!
    $capabilities: [ID!]!
    $isCustomTier: Boolean
    $customOrganisationsIds: [ID!]
  ) {
    data: createSubscriptionTier(
      name: $name
      monthlyCost: $monthlyCost
      annualCost: $annualCost
      freeTrialDuration: $freeTrialDuration
      maximumEmployees: $maximumEmployees
      maximumSubcontractors: $maximumSubcontractors
      maximumProjects: $maximumProjects
      capabilities: $capabilities
      isCustomTier: $isCustomTier
      customOrganisationsIds: $customOrganisationsIds
    ) {
      id
      name
      monthlyPlan {
        cost {
          currencyCode
          amount
        }
      }
      annualPlan {
        cost {
          currencyCode
          amount
        }
      }
      freeTrialDuration
      maximumEmployees
      maximumSubcontractors
      maximumProjects
      isFreeTier
      isInitialTier
      isCustomTier
      customOrganisationsIds
      capabilities {
        id
        description
        enabled
      }
      statistics {
        monthlySubscribers
        annualSubscribers
        freeSubscribers
      }
    }
  }
`;

export default ({ client, params }) => {
  try {
    if (params.data.isFreeTier) {
      // Remove fields specific to paid tiers to pass backend validation

    } else {
      params.data.monthlyCost = params.data.monthlyPlan.cost; // the field to create/create is not the same as the field we query
      params.data.monthlyCost.currencyCode = 'GBP'; // hardcoded for now as no locale implementation
      params.data.annualCost = params.data.annualPlan.cost;
      params.data.annualCost.currencyCode = 'GBP';
    }

    params.data.capabilities = params.data.capabilities
      .filter(capability => capability.enabled)
      .map(enabledCapability => enabledCapability.id); //only send ids of enabled permissiosn
    return client.mutate({
      mutation: createSubscriptionTierMutation,
      variables: {
        ...params.data,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
